// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_Z6B-1"};